import React from "react";
import axios from "axios";
import Chart from "react-google-charts";
import { 
    getFromLocalStorage,
    getRefreshToken 
} from './Utilities';

// Class component to display the table body for the country activity report
class ReportsCountryLoginsTableBody extends React.Component {

    render() {
        const countries = this.props.countries;

        if (countries.length > 0) {
            // Display countries data
            return (
                <tbody key={this.props.refresh}>
                    {countries.map(country => (
                        <tr key={country.Country}>
                            <td>{country.CountryName}</td>
                            <td>{country.Actions}</td>
                            <td>{country.Members}</td>
                        </tr>
                    ))}
                </tbody>
            );
        } 
    }
}

class ReportsCountryLoginsChart extends React.Component {

    render() {
        const countries = this.props.countries;
        const graphData = [];
        graphData[0] = ["Country", "Actions"];//first entry is the labels

        countries.map(function(country, index){
            graphData[index+1] = [country.CountryName, parseInt(country.Actions)];
        });

        const options = {
            colors: ['#CCC', '#44BEA6']
        };

        return (
            <Chart
                chartType="GeoChart"
                width="100%"
                height="600px"
                data={graphData}
                options={options}
                key={this.props.refresh}
            />
        );
    };
}

// Main component to display the country activity report
class ReportsCountryLogins extends React.Component {
    constructor(props) {
        super(props);

        // Retrieve and parse filters from local storage
        var filters = getFromLocalStorage("report_data");
        if (filters.constructor.name === "String") {
            filters = JSON.parse(filters);
        }

        const brand = (filters.ChooseBrands && typeof filters.ChooseBrands[0] != "undefined") ? filters.ChooseBrands[0] : null;
        var endpoint = "";
        if(brand) endpoint = "brand/" + brand.ID + "/stats/location";
        else endpoint = "brand/<UmbrellaID>/stats/location";

        // Setting initial state
        this.state = {
            view: props.view ? props.view : "table", 
            url: "react/process?endpoint=" + endpoint + "&hourly_cutoff=0&turnoffdebug=1&includeonetime=1&limit=10",
            countries: {},
            isLoading: true
        }
    }

    componentDidMount() {
        this.getData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.next !== this.props.next) {
            this.getData();
        }
    }

    // Function to fetch data
    getData() {
        axios.get(this.state.url).then(response => this.formatData(response.data));
    }

    // Function to format the fetched data
    formatData(data) {
        let countries = data.Countries || [];

        // Sorting countries based on the Actions property in descending order
        countries = countries.sort((a, b) => b.Actions - a.Actions);

        this.setState({ countries, isLoading: false});
    }

    render() {
        var no_results_url = "/dashboard/reports";
        const { isLoading, countries } = this.state;

        if (isLoading){
            return(
                <div className="row">
                    <div className="col-md-4"></div>
                    <div className="loading col-md-4">
                        <div className="react-loading big" style={this.props.loaderStyle}></div>
                    </div>
                    <div className="col-md-4"></div>
                </div>
            );
       }  else if(!isLoading && Object.keys(countries).length === 0) {
            // Handling no results found
            return (
                <tbody>
                    <tr colSpan="4">
                        <td>No activity found that matches that criteria. <a href={no_results_url}>Change your filters?</a></td>
                    </tr>
                </tbody>
            );
        }

        if (this.state.view === "graph") return this.renderGraph();
        return this.renderTable();
    }

    renderTable() {

        return (
            <div className="feed-countrylist">
                <table id="basic-datatable" className="table dt-responsive nowrap w-100">
                    <thead>
                        <tr>
                            <th>Country</th>
                            <th>Actions</th>
                            <th>Members</th>
                        </tr>
                    </thead>
                    <ReportsCountryLoginsTableBody
                        reportfilters={this.props.reportfilters}
                        memberfilters={this.props.memberfilters}
                        refresh={this.state.refresh}
                        countries={this.state.countries}
                    />
                </table>
            </div>
        );
    }

    renderGraph() {
        return (
            <div className="chart-countrylist">
                <ReportsCountryLoginsChart
                    reportfilters={this.props.reportfilters}
                    memberfilters={this.props.memberfilters}
                    refresh={this.state.refresh}
                    countries={this.state.countries}
                    style={this.props.loaderStyle}
                />
            </div>
        );
    }
}

ReportsCountryLogins.defaultProps = {
    loaderStyle: {
        "height": "200px"
    }
};

export default ReportsCountryLogins;

